import { type UserInputBillingInterval } from '@vy/types';
import type { FC } from 'react';
import { VySelectField } from '../../../../../../design-system-adapters/forms';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { BILLING_INTERVAL_OPTIONS, getBillingIntervalLabel } from './billing-interval-options';

type UserInputBillingIntervalSelectProps = {
  fieldNamePrefix: 'usageProducts' | 'fixedProducts';
  productIndex: number;
  disabled?: boolean;
};

export const UserInputBillingIntervalSelect: FC<UserInputBillingIntervalSelectProps> = ({
  fieldNamePrefix,
  productIndex,
  disabled,
}) => {
  const billingIntervalPath = `${fieldNamePrefix}.${productIndex}.billingInterval` as const;

  return (
    <VySelectField<PlanInputForm, UserInputBillingInterval>
      name={billingIntervalPath}
      label="Billing interval"
      helperText="How often usage is aggregated and invoiced"
      options={BILLING_INTERVAL_OPTIONS}
      getOptionLabel={getBillingIntervalLabel}
      disabled={disabled}
      isOptionEqualToValue={(option, value) => option === value}
      data-vy="usage-charge-drawer-billing-interval-select"
    />
  );
};
